import React, { forwardRef } from 'react'

import { preventWheelInput } from '@/lib/helpers'

import * as S from './styles'

import type { GroupTextInputProps } from './types'

export const GroupTextInput = forwardRef<HTMLInputElement, GroupTextInputProps>(
  (
    { name, postfix, inputWidth, readOnly, dataCy, type, ...restProps },
    ref
  ) => (
    <S.InputWrapper>
      <S.TextInput
        $inputWidth={inputWidth}
        ref={ref}
        name={name}
        readOnly={readOnly}
        data-cy={dataCy}
        type={type}
        onWheel={type === 'number' ? preventWheelInput : undefined}
        {...restProps}
      />
      {postfix && <S.Postfix $readOnly={readOnly}>{postfix}</S.Postfix>}
    </S.InputWrapper>
  )
)

GroupTextInput.displayName = 'GroupTextInput'
